export const MOTION_STORAGE_KEY = "geseidl.portal.motion";
export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export type MotionPreference = "system" | "active" | "reduced";
export type ResolvedMotion = "active" | "reduced";

const isMotionPreference = (value: string | null): value is MotionPreference =>
  value === "system" || value === "active" || value === "reduced";

export const readMotionPreference = (
  storage: Pick<Storage, "getItem"> | undefined,
): MotionPreference => {
  if (!storage) {
    return "system";
  }

  try {
    const value = storage.getItem(MOTION_STORAGE_KEY);
    return isMotionPreference(value) ? value : "system";
  } catch {
    return "system";
  }
};

export const writeMotionPreference = (
  storage: Pick<Storage, "setItem"> | undefined,
  value: MotionPreference,
): void => {
  if (!storage) {
    return;
  }

  try {
    storage.setItem(MOTION_STORAGE_KEY, value);
  } catch {
    // The preference is optional and must not block the interface.
  }
};

export const resolveMotionPreference = (
  preference: MotionPreference,
  systemReduced: boolean,
): ResolvedMotion => {
  if (systemReduced || preference === "reduced") {
    return "reduced";
  }
  return "active";
};
